import Repository from '../../repositories/RepositoryFactory';
const ccmConditionsRepository = Repository.get('ccmConditions');

export default {
	namespaced: true,
	state: {
		ccmConditionsByPatientId: [],
		ccmConditionsByCCMRecordId: [],
		ccmCondition: null,
		ccmConditionHistory: null,
	},
	mutations: {
		STORE_CCM_CONDITIONS_BY_PATIENT_ID (state, payload) {
			state.ccmConditionsByPatientId = payload;
		},
		STORE_CCM_CONDITIONS_BY_CCM_RECORD_ID (state, payload) {
			state.ccmConditionsByCCMRecordId = payload;
		},
		STORE_CCM_CONDITION (state, payload) {
			state.ccmCondition = payload;
		},
		STORE_CCM_CONDITION_HISTORY (state, payload) {
			state.ccmConditionHistory = payload;
		},
		UPDATE_CCM_CONDITION (state, payload) {
			state.ccmCondition = {
				...state.ccmCondition,
				...payload,
			};
		},
		UPDATE_CCM_CONDITION_IN_PATIENT_LIST (state, id, payload) {
			const index = state.ccmConditionsByPatientId.findIndex((record) => record.id === id);
			if (index !== -1) {
				state.ccmConditionsByPatientId.splice(index, 1, {
					...state.ccmConditionsByPatientId[index],
					...payload,
				});
			}
		},
		REMOVE_CCM_CONDITION (state, id) {
			state.ccmConditionsByPatientId = state.ccmConditionsByPatientId.filter((record) => record.id !== id);
		},
	},
	actions: {
		async getCCMConditionsByPatientId ({ commit }, patientId) {
			const response = await ccmConditionsRepository.getCCMConditionByPatientId(patientId);
			var conditions = [];
			if (response.data) {
				response.data.forEach((condition) => {
					if (condition.isPrimary) {
						conditions.unshift(condition);
					} else {
						conditions.push(condition);
					}
				});
			}
			commit('STORE_CCM_CONDITIONS_BY_PATIENT_ID', conditions);
		},
		async getCCMConditionsByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmConditionsRepository.getCCMConditionByCCMRecordId(ccmRecordId);
			var conditions = [];
			if (response.data) {
				response.data.forEach((condition) => {
					if (condition.isPrimary) {
						conditions.unshift(condition);
					} else {
						conditions.push(condition);
					}
				});
			}
			commit('STORE_CCM_CONDITIONS_BY_CCM_RECORD_ID', conditions);
		},
		async getCCMCondition ({ commit }, id) {
			const response = await ccmConditionsRepository.getCCMCondition(id);
			commit('STORE_CCM_CONDITION', response.data);
		},
		async addCCMCondition ({ commit }, body) {
			return await ccmConditionsRepository.addCCMCondition(body);
		},
		async updateCCMCondition ({ commit }, request) {
			commit('UPDATE_CCM_CONDITION', request.body);
			commit('UPDATE_CCM_CONDITION_IN_PATIENT_LIST', request.id, request.body);
			return await ccmConditionsRepository.updateCCMCondition(request.id, request.body);
		},
		async deleteCCMCondition ({ commit }, id) {
			commit('REMOVE_CCM_CONDITION', id);
			return await ccmConditionsRepository.deleteCCMCondition(id);
		},
		async editConditionHistory ({ commit }, request) {
			return await ccmConditionsRepository.editConditionHistory(request.id, request.body);
		},
		async deleteConditionHistory ({ commit }, id) {
			return await ccmConditionsRepository.deleteConditionHistory(id);
		},
	},
};
